//export const api = 'http://34.78.112.125:8080/v1/graphql'
//export const api = 'http://63.33.214.110:8080/v1/graphql' 
export const api = 'https://api.barcelonabridalweek.com/v1/graphql'  

import axios from 'axios'
axios.defaults.headers.common['x-hasura-admin-secret'] = 'gHHdxsykQrqZc6rF'
//'Authorization': 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNvcG9ydGUuY2xpZW50ZXNAZmlyYWJhcmNlbG9uYS5jb20iLCJpZCI6NDQsImV4aGliaXRvcl9pZCI6bnVsbCwicm9sZSI6Imdyb3VwMCIsInNkYSI6dHJ1ZSwiYWNjb3VudF9pZCI6MzgsImJyYW5kX2lkIjpudWxsLCJpYXQiOjE2MDAxMDk1NTEsImV4cCI6MTYwMjcwMTU1MX0.Irl2ycpyg7cOwJ6nKhG1PVyCEIJL-93anaNQTR4fmls'

const queriesCrush = {
  getLikesByQuestionId:`
	  query getLikesByQuestionId($qId: String!) {
		  likes: interactions_crush_likes(where: {question_id: {_eq: $qId}}) {
		    count_likes
		    like
		    image_url
		    product_id
		    question_id
		  }
		  profiles: interactions_crush_all(distinct_on: profile, where: {question_id: {_eq: $qId}}) {
		    profile
		  }
		  custom_profiles: interactions_crush_all(distinct_on: custom_profile, where: {question_id: {_eq: $qId}}) {
		    custom_profile
		  }
		  countries: interactions_crush_all(distinct_on: country, where: {question_id: {_eq: $qId}}) {
		    country
		  }
		  num_users: interactions_crush_aggregate(where: {question_id: {_eq: $qId}}, distinct_on: user_id) {
		    aggregate {
		      count
		    }
		  }		  
		}
  `,
  getFilteredLikesByQuestionId:`
	  query getFilteredLikesByQuestionId($qId: String!,$custom_profile_is_null: Boolean, $profiles: [String!], $custom_profiles: [String!], $countries: [String!]) {
		  likes: interactions_crush_all(where: {question_id: {_eq: $qId}, profile: {_in: $profiles}, custom_profile:{_in: $custom_profiles}, country: {_in: $countries}}) {
		    count_likes
		    product_id
		    image_url
		    question_id
		    like
		    country
		    custom_profile
		    profile
		  }
	  	profiles: interactions_crush_all_aggregate(where: {question_id: {_eq: $qId}, profile: {_in: $profiles}, custom_profile: {_in: $custom_profiles}, country: {_in: $countries}}, distinct_on: profile) {
		    aggregate {
		      count
		    }
	    	nodes{
		    	profile
		  	}
		}
	    custom_profiles: interactions_crush_all_aggregate(where: {question_id: {_eq: $qId}, profile: {_in: $profiles}, custom_profile: {_in: $custom_profiles}, country: {_in: $countries}}, distinct_on: custom_profile) {
		    aggregate {
		      count
		    }
	    	nodes{
		    	custom_profile
		    }
		}
	  	countries: interactions_crush_all_aggregate(where: {question_id: {_eq: $qId}, profile: {_in: $profiles}, custom_profile: {_in: $custom_profiles}, country: {_in: $countries}}, distinct_on: country) {
		    aggregate {
		      count
		    }
	    	nodes{
	        	country
	    	}
		}
	}	
  `,
  getFilteredLikesByQuestionIdNull:`
	  query getFilteredLikesByQuestionId($qId: String!,$custom_profile_is_null: Boolean, $profiles: [String!], $custom_profiles: [String!], $countries: [String!]) {
		  likes: interactions_crush_all(where: {question_id: {_eq: $qId}, profile: {_in: $profiles}, _or: [ {custom_profile: {_is_null: $custom_profile_is_null}},{custom_profile:{_in:$custom_profiles}} ], country: {_in: $countries}}) {
		    count_likes
		    product_id
		    image_url
		    question_id
		    like
		    country
		    custom_profile
		    profile
		  }
	  	profiles: interactions_crush_all_aggregate(where: {question_id: {_eq: $qId}, profile: {_in: $profiles}, _or: [ {custom_profile: {_is_null: $custom_profile_is_null}},{custom_profile:{_in:$custom_profiles}} ], country: {_in: $countries}}, distinct_on: profile) {
		    aggregate {
		      count
		    }
	    	nodes{
		    	profile
		  	}
		}
	    custom_profiles: interactions_crush_all_aggregate(where: {question_id: {_eq: $qId}, profile: {_in: $profiles}, _or: [ {custom_profile: {_is_null: $custom_profile_is_null}},{custom_profile:{_in:$custom_profiles}} ], country: {_in: $countries}}, distinct_on: custom_profile) {
		    aggregate {
		      count
		    }
	    	nodes{
		    	custom_profile
		    }
		}
	  	countries: interactions_crush_all_aggregate(where: {question_id: {_eq: $qId}, profile: {_in: $profiles}, _or: [ {custom_profile: {_is_null: $custom_profile_is_null}},{custom_profile:{_in:$custom_profiles}} ], country: {_in: $countries}}, distinct_on: country) {
		    aggregate {
		      count
		    }
	    	nodes{
	        	country
	    	}
		}
	}	
  `,
   getNumUsersFitlteredLikesByQuestionId:`
	query getNumUsersFitlteredLikesByQuestionId($qId: String!, $profiles: [profiles_enum!], $custom_profiles: [profiles_custom_enum!], $countries: [countries_enum!]) {
	  num_users: interactions_crush_aggregate(where: {question_id: {_eq: $qId}, user: {profile: {_in: $profiles}, custom_profile:{_in: $custom_profiles}, country: {_in: $countries}}}, distinct_on: user_id) {
	    aggregate {
	      count
	    }
	  }
	}  		
  `,
  getNumUsersFitlteredLikesByQuestionIdNull:`
	query getNumUsersFitlteredLikesByQuestionIdNull($qId: String!,$custom_profile_is_null: Boolean, $profiles: [profiles_enum!], $custom_profiles: [profiles_custom_enum!], $countries: [countries_enum!]) {
	  num_users: interactions_crush_aggregate(where: {question_id: {_eq: $qId}, user: {profile: {_in: $profiles}, _or: [ {custom_profile: {_is_null: $custom_profile_is_null}},{custom_profile:{_in:$custom_profiles}} ], country: {_in: $countries}}}, distinct_on: user_id) {
	    aggregate {
	      count
	    }
	  }
	}  		
  `,
	
  getQuestionsIdsByBrandId: ` 
   query getQuestionsIdsByBrandId($bId: Int!){
      interactions_crush_brand_id_question_id(where: {brand_id: {_eq: $bId}}) {     
        question_id
      }
    }
  `
}

export async function fetchLikesByQuestionId(questionId){
	let response = {}
	let results = {}
	
	response = await axios.post(api, {
		query: queriesCrush.getLikesByQuestionId,
		variables: {
			qId: questionId 
		}

	})
	//console.log("fetchLikesByQuestionId",response)
	results = response.data.data

	return results
}

export async function fetchFilteredResultsByQuestionId(questionId,{profiles,custom_profiles,countries}){
	let response = {}
	let results = {}
	let vars = {}

	vars.qId = questionId
	if (profiles.length > 0)
		vars.profiles = profiles
	if (custom_profiles.length > 0){		
		if (custom_profiles.includes("null")){
			vars.custom_profile_is_null = true
			vars.custom_profiles = custom_profiles.filter((cp) => cp != "null")
		}else{
			vars.custom_profiles = custom_profiles
			vars.custom_profile_is_null = false
		}
	}
	if (countries.length > 0)
		vars.countries = countries

	// console.log("vars", vars)	

	if(vars.custom_profile_is_null){
		response = await axios.post(api, {
			query: queriesCrush.getFilteredLikesByQuestionIdNull,
			variables: vars

		})
	}else{
		delete vars.custom_profile_is_null
		response = await axios.post(api, {
			query: queriesCrush.getFilteredLikesByQuestionId,
			variables: vars

		})
	}
	
	//console.log("fetchFilteredResultsByQuestionId",response)
	results = response.data.data
	
	return results
}

export async function fetchNumUsersFilteredResultsByQuestionId(questionId,{profiles,custom_profiles,countries}){
	let response = {}
	let results = {}
	let vars = {}

	vars.qId = questionId
	if (profiles.length > 0)
		vars.profiles = profiles
	if (custom_profiles.length > 0){		
		if (custom_profiles.includes("null")){
			vars.custom_profile_is_null = true
			vars.custom_profiles = custom_profiles.filter((cp) => cp != "null")
		}else{
			vars.custom_profiles = custom_profiles
			vars.custom_profile_is_null = false

			
		}
	}
	if (countries.length > 0)
		vars.countries = countries
	
	if(vars.custom_profile_is_null){
		response = await axios.post(api, {
			query: queriesCrush.getNumUsersFitlteredLikesByQuestionIdNull,
			variables: vars

		})
	}else{
		delete vars.custom_profile_is_null
		response = await axios.post(api, {
			query: queriesCrush.getNumUsersFitlteredLikesByQuestionId,
			variables: vars

		})
	}
	
	//console.log("fetchNumUsersFilteredResultsByQuestionId",response)
	results = response.data.data

	return results
}

export async function fetchQuestionsByBrandId(brandId){
	let response = {}

	response = await axios.post(api,{
		query: queriesCrush.getQuestionsIdsByBrandId,
		variables:{
			bId: brandId
		}
	})

	//console.log("fetchQuestionsByBrandId", response)
	let results = response.data.data.interactions_crush_brand_id_question_id

	return results.map((el) => el.question_id)
}











